import { createSlice } from "@reduxjs/toolkit";

import { updatePassword, createNewUser } from "../../apis";

export const profile = createSlice({
  name: "userProfile",
  initialState: {
    loading: false,
    error: "",
    updateProfileSuccess: false,
    createNewUserSuccess: false,
  },
  reducers: {
    clear: (state, action) => {
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updatePassword.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(updatePassword.fulfilled, (state, action) => {
      state.loading = false;
      state.updateProfileSuccess = true;
    });
    builder.addCase(updatePassword.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
    builder.addCase(createNewUser.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(createNewUser.fulfilled, (state, action) => {
      state.loading = false;
      state.createNewUserSuccess = true;
    });
    builder.addCase(createNewUser.rejected, (state, action) => {
      state.error = action.payload.message;
      state.loading = false;
    });
  },
});

export const { clear } = profile.actions;

export default profile.reducer;
